<!--
    les animations sont basées sur ce tuto :
    https://medium.com/google-developer-experts/angular-supercharge-your-router-transitions-using-new-animation-features-v4-3-3eb341ede6c8
-->
<main>
  <router-outlet></router-outlet>
</main>
<ng-template #discussionRef></ng-template>
